import PostServiceApi from "../../services/api/post-service";
import UserApi from "../../services/api/user";

const handleAdVisibility = async ({ postId, data }) => {
  try {
    const response = await PostServiceApi.updateAdVisibility({ postId, data });
    return response;
  } catch (error) {
    throw error;
  }
};

const updatePreferences = async ({ preferences }) => {
  try {
    const response = await UserApi.postUserPreferences({ preferences });
    if (!response.success) {
      throw new Error("Error Updating Preferences");
    }
    return response;
  } catch (error) {
    throw error;
  }
};

const SettingsDomain = {
  handleAdVisibility,
  updatePreferences,
};

export default SettingsDomain;
